import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/faq/PrivacyAndSecurity-q2-03-movil.jpg")